// Определение «тона» изображения логотипа: light (почти белый/светлый),
// dark (почти чёрный/тёмный) или mixed (цветной/средний). Нужно, чтобы под
// светлый лого класть тёмную подложку (и наоборот) — иначе он сливается с
// поверхностью. Считаем среднюю яркость по НЕпрозрачным пикселям на уменьшенной
// копии. Результат кэшируется по src, чтобы не гонять canvas повторно.

const toneCache = new Map();

export function analyzeImageTone(src) {
    if (!src) return Promise.resolve('mixed');
    if (toneCache.has(src)) return Promise.resolve(toneCache.get(src));

    const promise = new Promise((resolve) => {
        try {
            const img = new Image();
            // Наши логотипы отдаются с того же origin (или data:), поэтому canvas
            // не «портится». crossOrigin на всякий случай для внешних URL.
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                try {
                    const w = 32;
                    const h = 32;
                    const canvas = document.createElement('canvas');
                    canvas.width = w;
                    canvas.height = h;
                    const ctx = canvas.getContext('2d', { willReadFrequently: true });
                    ctx.drawImage(img, 0, 0, w, h);
                    const { data } = ctx.getImageData(0, 0, w, h);

                    let lumSum = 0;
                    let alphaSum = 0;
                    for (let i = 0; i < data.length; i += 4) {
                        const a = data[i + 3] / 255;
                        if (a < 0.1) continue; // прозрачные пиксели не учитываем
                        const r = data[i];
                        const g = data[i + 1];
                        const b = data[i + 2];
                        const l = 0.2126 * r + 0.7152 * g + 0.0722 * b; // 0..255
                        lumSum += l * a;
                        alphaSum += a;
                    }

                    if (alphaSum === 0) {
                        resolve('mixed');
                        return;
                    }
                    const avg = lumSum / alphaSum; // средняя яркость 0..255
                    let tone;
                    if (avg >= 170) tone = 'light';
                    else if (avg <= 70) tone = 'dark';
                    else tone = 'mixed';
                    resolve(tone);
                } catch (_) {
                    resolve('mixed');
                }
            };
            img.onerror = () => resolve('mixed');
            img.src = src;
        } catch (_) {
            resolve('mixed');
        }
    }).then((tone) => {
        toneCache.set(src, tone);
        return tone;
    });

    return promise;
}
